import Blue from "~/core";

new Blue({
	name: 'List Items',
	selector: ".list-items",
	setup(listItem) {
		var heading = listItem.querySelector('h1');
    heading.addEventListener("click", (e) => {
      e.currentTarget.style.color= "blue"
    });
	}
});